import { Timezone } from './timezone';
import { User } from './user';
import { CarrierDriver, CarrierFleetDriver } from './carrier';
import { RecordKeeperDriver } from './recordkeeper';

export class Driver {
    Id: number;
    UserName: string;
    Identifier: string;
    FirstName: string;
    LastName: string;
    PhoneNumber: string;
    Email: number;
    Address1: string;
    Address2: string;
    City: string;
    ZipCode: string;
    State: string;
    LicenceNumber: string;
    LicenceType: string;
    LicenceExpiry: string;
    LicenceState: string;
    DateOfBirth: string;
    TimeZoneId: number;
    TimeZone: Timezone;
    Status: string;
    IsDeleted: boolean;
    CarrierDrivers: CarrierDriver[];
    DriverNow: string;
    CarrierFleetDrivers: CarrierFleetDriver[];
    FullName: string;
    BaseState: string;
    RecordKeeperDrivers: RecordKeeperDriver[];
    ActivatedDateTimeUtc: string;
    EWDUnifiedMode: boolean;
    EWDLogoutSynchronisation: boolean;
}

export class DriverPage {
    TotalNumber: number;
    List: Driver[];
}

export class DriverList {
    Id: number;
    Username: string;
    FullName: string;
    Name: string;
}
